import { useFormUtils } from "@/app/hooks/useFormUtils";
import clsx from "clsx";
import React from "react";
import {
  FieldError,
  FieldErrorsImpl,
  LiteralUnion,
  Merge,
  Message,
  RegisterOptions,
  UseFormRegisterReturn,
} from "react-hook-form";
export type IMessageErrorType = LiteralUnion<keyof RegisterOptions, string>;

export interface IFormFieldErrorMessages {
  type: IMessageErrorType;
  message: Message;
}

interface CustomHTMLProps extends React.HTMLProps<HTMLInputElement> {
  colorClassName: string;
  descriptionContent?: React.ReactNode;
  containerClassName?: string;
  key?: string;
  fieldError: Merge<FieldError, FieldErrorsImpl<any>> | FieldError | undefined;
  errorMessages: IFormFieldErrorMessages[];
  register: UseFormRegisterReturn<string>;
}
type MergedProps = React.HTMLProps<HTMLElement> & CustomHTMLProps;
const SimpleCheckboxWithError: React.FC<MergedProps> = ({
  colorClassName,
  containerClassName,
  errorMessages,
  fieldError,
  descriptionContent,
  register,
  ...props
}) => {
  const { deduceFormFieldErrors, isFormFieldValid } = useFormUtils();
  const reducedErrorMessages = deduceFormFieldErrors(errorMessages, fieldError);

  const isValid = isFormFieldValid(reducedErrorMessages);

  return (
    <div className={clsx("relative flex items-start", containerClassName)}>
      <div className="flex h-6 items-center">
        <input
          {...props}
          {...register}
          type="checkbox"
          className={clsx(
            `h-4 w-4 rounded ${isValid ? "border-gray-300" : "border-red-400"}  focus:ring-current`,
            colorClassName,
          )}
        />
      </div>
      <div className="ml-0 text-sm leading-6">{descriptionContent && descriptionContent}</div>
    </div>
  );
};

export default SimpleCheckboxWithError;
